import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as o from "react";
import { c as s } from "./index.CxSWpsOB.js";
const n = o.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: s("tw-rounded-8 tw-border tw-border-gray-300 tw-bg-base-white tw-w-full tw-flex tw-flex-col", a), ...t }));
n.displayName = "FunctionalCard";
const l = o.forwardRef(({
  className: a,
  closeButton: t,
  children: e,
  closeButtonClasses: d,
  ...w
}, i) => /* @__PURE__ */ r.jsxs("div", { ref: i, className: s("tw-flex tw-py-12 tw-px-16 tw-border-b tw-border-gray-300 tw-relative", a), ...w, children: [
  /* @__PURE__ */ r.jsx("div", { className: s("tw-relative tw-z-40", d, {
    "tw-pr-28": !!t
  }), children: e }),
  t && /* @__PURE__ */ r.jsx("div", { className: "tw-absolute tw-right-16 tw-top-0 tw-bottom-0 tw-z-50 tw-flex tw-items-center tw-justify-center", children: t })
] }));
l.displayName = "FunctionalCardHeader";
const c = o.forwardRef(({
  className: a,
  children: t,
  ...e
}, d) => /* @__PURE__ */ r.jsx("h3", { ref: d, className: s("tw-headline-1-m tw-text-gray-900 tw-m-0", a), ...e, children: t }));
c.displayName = "FunctionalCardTitle";
const m = o.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: s("tw-body-2 tw-text-gray-600", a), ...t }));
m.displayName = "FunctionalCardDescription";
const f = o.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: s("tw-body-1-long tw-text-gray-600 tw-m-0 tw-p-16", a), ...t }));
f.displayName = "FunctionalCardContent";
const x = o.forwardRef(({
  className: a,
  ...t
}, e) => /* @__PURE__ */ r.jsx("div", { ref: e, className: s("tw-flex tw-py-12 tw-px-16 tw-border-t tw-border-gray-300", a), ...t }));
x.displayName = "FunctionalCardFooter";
export {
  n as F,
  f as a,
  m as b,
  x as c,
  l as d,
  c as e
};
//# sourceMappingURL=FunctionalCard.DP-yCR_u.js.map
